'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'tree';
var width = 512;
var height = 512;
var aliases = [127794];
var unicode = 'f1bb';
var svgPathData = ['M103.6 400l304.9 0c-60.4-81.8-95.9-129.7-106.4-144l74.9 0c-49.7-68.6-80.6-111.2-92.8-128l56 0-84.1-99-84.1 99 56 0c-12.2 16.8-43.1 59.4-92.8 128l74.9 0c-10.5 14.2-46 62.3-106.4 144z', 'M274.4-23.5l136 160 33.6 39.5-65.7 0c49.7 68.6 80.7 111.2 92.8 128l-73.9 0c60.4 81.8 95.9 129.7 106.4 144l-223.6 0 0 96-48 0 0-96-223.6 0c10.5-14.2 46-62.3 106.4-144L41 304c12.1-16.8 43.1-59.4 92.8-128l-65.7 0 33.6-39.5 136-160 18.3-21.5 18.3 21.5zM171.9 128l56 0c-12.2 16.8-43.1 59.4-92.8 128l74.9 0c-10.5 14.2-46 62.3-106.4 144l304.9 0c-60.4-81.8-95.9-129.7-106.4-144l74.9 0c-49.7-68.6-80.6-111.2-92.8-128l56 0-84.1-99-84.1 99z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTree = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;